import { _ as __assign } from './bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from './bundle-B5EHFFGW.js';
import { u as useThread } from './bundle-CNmV5PTy.js';

var SuggestedMentionList = function (props) {
    var currentChannel = useThread().state.currentChannel;
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props, { currentChannel: currentChannel })));
};

export { SuggestedMentionList as S };
//# sourceMappingURL=bundle-CP9XTkJc.js.map
